import Typography from '@mui/material/Typography';

const headlineSx = {
  position: 'absolute' as const,
  color: '#fff',
  fontWeight: 600,
  pointerEvents: 'none' as const,
  display: { xs: 'none', md: 'block' },
};

export function LoginMarketingCopy() {
  return (
    <>
      <Typography
        sx={{
          ...headlineSx,
          left: { md: 32, lg: 56 },
          top: { md: '32%', lg: '34%' },
          maxWidth: 273,
          fontSize: { md: 22, lg: 26 },
          lineHeight: '37px',
        }}
      >
        Build beautiful spaces, seamlessly.
      </Typography>
      <Typography
        sx={{
          ...headlineSx,
          right: { md: 32, lg: 48 },
          top: { md: 48, lg: 68 },
          maxWidth: 358,
          fontSize: { md: 20, lg: 24 },
          lineHeight: '34px',
          textAlign: 'right',
        }}
      >
        Create, manage and share your FF&E proposals.
      </Typography>
      <Typography
        sx={{
          ...headlineSx,
          right: { md: 32, lg: 48 },
          bottom: { md: 160, lg: 200 },
          maxWidth: 220,
          fontSize: 16,
          lineHeight: '24px',
          textAlign: 'right',
        }}
      >
        Manage your projects with clarity.
      </Typography>
    </>
  );
}
